import { useTheme } from "@mui/material";
import type { Feature, Polygon, MultiPolygon } from "geojson";
import { GeoJSON } from "react-leaflet";

interface Props {
  features: Feature<Polygon | MultiPolygon>[];
}

export function SelectedCaseFeaturePreview(props: Props) {
  const { features } = props;
  const { palette } = useTheme();

  return (
    <>
      {features.map((feature, idx) => (
        <GeoJSON
          key={feature.id || idx}
          data={feature}
          style={{ color: palette.primary.main, opacity: 1, fillOpacity: 0.2 }}
          pmIgnore={true}
        />
      ))}
    </>
  );
}
